
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/[path]",
      function () {
        return require("private-next-pages/dashboard/[path].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/[path]"])
      });
    }
  